<template>
  <gj-modal
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告活动</template>
    <template #content>
      <el-form  ref="form" :model="form">
        <app-add-title>广告活动</app-add-title>
        <app-campaign-base-info
            ref="base"
            :form="form.baseInfoForm"
            :maxTime="maxTime"
            :marketId="marketId"
        ></app-campaign-base-info>
        
        <app-add-title>竞价策略</app-add-title>
        <app-bid-strategy-picker
            ref="bidStrategyPicker"
            :form="form.bidStrategyPickerForm"
            style="padding: 0 0 0 0px;"
        ></app-bid-strategy-picker>
  
        <div style="margin-top: 28px;"></div>
        <app-add-title>广告组</app-add-title>
        <el-form-item
            prop="groupName"
            class="form-margin-24"
            :rules="[
              { required: true, message: '请输入广告组名称', trigger: ['change', 'blur'] }
            ]"
            label-width="100px">
          <template #label>
            <span>广告组名称</span>
            <gj-help style="padding-left: 3px">	仅在您管理广告时可见。</gj-help>
          </template>
          <gj-input
              v-model="form.groupName"
              width="200px"
              placeholder="请输入">
          </gj-input>
        </el-form-item>
    
        <app-add-title>商品</app-add-title>
        <app-product-picker
            ref="productPicker"
            :market-id="marketId"
            :form="form.productPickerForm"
            title="商品"
        ></app-product-picker>
  
        <!-- 手动投放 -->
        <template v-if="manual">
    
          <div style="margin-top: 28px;"></div>
          <app-add-title>关键词与竞价</app-add-title>
          <app-keyword-bid-picker
              ref="keywordBidPicker"
              :market-id="marketId"
              :form="form"
              :asin-list="pickedAsinList"
          ></app-keyword-bid-picker>
    
          <!-- 关键词投放 -->
          <template v-if="keywordTarget">
            <div style="margin-top: 28px;"></div>
            <app-add-title>否定关键词（选填）</app-add-title>
            <app-neg-keyword-picker
                :form="form.negKeywordPickerForm"
                title="否定关键词"
                :match-type-option="AdNegKeywordEnum.SP.matchTypeOption"
            ></app-neg-keyword-picker>
          </template>
          <!-- 商品投放 -->
          <template v-if="productTarget">
            <div style="margin-top: 28px;"></div>
            <app-add-title>否定商品投放（选填）</app-add-title>
            <app-manual-neg-target-picker
                v-if="manual"
                :market-id="marketId"
                :form="form.manualNegTargetPickerForm"
                title="否定商品"
            ></app-manual-neg-target-picker>
          </template>
        </template>
  
        <!-- 自动投放 -->
        <template v-if="auto">
          <div style="margin-top: 28px;"></div>
          <app-add-title>竞价</app-add-title>
          <app-bid-picker
              ref="bidPicker"
              :form="form.bidPickerForm"
          ></app-bid-picker>
    
          <div style="margin-top: 28px;"></div>
          <app-add-title>否定关键词（选填）</app-add-title>
          <app-neg-keyword-picker
              :form="form.negKeywordPickerForm"
              title="否定关键词"
              :match-type-option="AdNegKeywordEnum.SP.matchTypeOption"
          ></app-neg-keyword-picker>
    
          <div style="margin-top: 28px;"></div>
          <app-add-title>否定商品投放（选填）</app-add-title>
          <app-auto-neg-target-picker
              :market-id="marketId"
              :form="form.autoNegTargetPickerForm"
              title="否定商品"
          ></app-auto-neg-target-picker>
        </template>
      
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import AppAddTitle from "../common/title";
  import AppProductPicker from "../common/product-picker";
  import AppNegKeywordPicker from "../common/neg-keyword-picker";
  import AppBidPicker from "../common/bid-picker";
  import AppKeywordBidPicker from "../common/keyword-bid-picker";
  import AppBidStrategyPicker from "../common/bid-strategy-picker";
  import AppCampaignBaseInfo from "../common/campaign-base-info";
  import AppManualNegTargetPicker from "../common/manual-neg-target-picker";
  import AppAutoNegTargetPicker from "../common/auto-neg-target-picker";
  import {modalMixIn} from "@/minxins";
  import { SP } from "@/api/ad";
  import {convertToDate} from "@/utils/date.util";
  import {defaultVal, isMeaningful} from "@/utils/common";
  import {adStoreMixin} from "@/views/modules/ad/common/mixin";
  import {
    AdBidStrategyTypeEnum,
    AdBidTypeEnum,
    AdCampaignEnum, AdGroupEnum, AdKeywordEnum,
    AdNegKeywordEnum,
    GroupType
  } from "@/views/modules/ad/common/enum";
  export default {
    name: "app-add-sp-ad-campaign",
    mixins: [modalMixIn, adStoreMixin],
    components: {
      AppAutoNegTargetPicker,
      AppManualNegTargetPicker,
      AppCampaignBaseInfo,
      AppBidStrategyPicker,
      AppKeywordBidPicker,
      AppBidPicker,
      AppNegKeywordPicker,
      AppProductPicker, AppAddTitle
    },
    props: {
      marketId: {
        required: true
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignName: null,
            portfolioId: null,
            portfolioName: null,
            budget: null,
            startDate: null,
            endDate: null,
            targetingType: AdCampaignEnum.SP.targetingType.AUTO,
          },
          bidStrategyPickerForm: {
            bidStrategyType: AdBidStrategyTypeEnum.LEGACY_FOR_SALES,
            homePercentage: null,
            productPercentage: null
          },
          productPickerForm: {
            items: []
          },
          negKeywordPickerForm: {
            items: [],
            matchType: AdNegKeywordEnum.SP.matchType.NEGATIVE_EXACT
          },
          manualNegTargetPickerForm: {
            items: []
          },
          autoNegTargetPickerForm: {
            items: []
          },
          defaultBid: 0.75,
          keywordPickerForm: {
            items: [],
            inputMatchTypes: [
              AdKeywordEnum.SP.matchType.EXACT
            ],
            matchTypes: [
              AdKeywordEnum.SP.matchType.EXACT,
              AdKeywordEnum.SP.matchType.PHASE,
              AdKeywordEnum.SP.matchType.BROAD
            ],
            bid: null,
          },
          targetType: AdGroupEnum.SP.targetingType.KEYWORD,
          bidPickerForm: {
            bidType: AdBidTypeEnum.default,
            defaultBid: 0.75,
            items: [],
          },
          productTargetPickerForm: {
            items: [],
            bid: null
          }
        },
        AdNegKeywordEnum: AdNegKeywordEnum,
      }
    },
    created() {
      this.form.defaultBid = this.adStore.SP.defaultBid;
      this.form.bidPickerForm.defaultBid = this.adStore.SP.defaultBid;
    },
    computed: {
      maxTime() {
        return this.adStore.SP.market?.datetime
      },
      manual() {
        return this.form.baseInfoForm.targetingType === AdCampaignEnum.SP.targetingType.MANUAL;
      },
      auto() {
        return this.form.baseInfoForm.targetingType === AdCampaignEnum.SP.targetingType.AUTO;
      },
      keywordTarget() {
        return this.form.targetType === AdGroupEnum.SP.targetingType.KEYWORD;
      },
      productTarget() {
        return this.form.targetType === AdGroupEnum.SP.targetingType.PRODUCT;
      },
      pickedAsinList() {
        return (this.form.productPickerForm.items || []).map(e => e.asin);
      },
    },
    methods: {
      checkFrom(ref) {
        return new Promise((resolve, reject) => {
          if(!ref) return resolve();
          ref.validate(valid => {
            valid ? resolve() : reject()
          });
        })
      },
      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'bidStrategyPicker', 'keywordBidPicker', 'bidPicker', 'productPicker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid, this.checkFrom(this.$refs.form)])
          .then(() => this.campaignsAdd())
          .catch((error) => console.log('zs', error))
          .complete(() => this.confirmLoading = false)
      },
      // 商品广告创建构建请求数据
      async campaignsAddParams() {
        // 关键词参数
        const keywordsParams = {
          marketId: this.marketId,
          params: this.form.keywordPickerForm.items.map(item => ({
            keywordText: item.keyword,
            matchType: item.matchType,
            bid: item.bid
          }))
        };
        // 否定关键词参数
        const negativeKeywordsParams = {
          marketId: this.marketId,
          params: this.form.negKeywordPickerForm.items.map(item => ({
            keywordText: item.keyword,
            matchType: item.matchType
          }))
        };
        // 商品投放参数
        const targetsParams = {
          marketId: this.marketId,
          params: this.form.productTargetPickerForm.items.map(item => ({
            bid: item.bid,
            categoryId: defaultVal(item.categoryId, null),
            categoryName: defaultVal(item.categoryName, null),
            asin: defaultVal(item.asin, null),
            brandId: defaultVal(item.brandId, null),
            brandName: defaultVal(item.brandName, null),
            minPrice: defaultVal(item.lowPrice, null),
            maxPrice: defaultVal(item.maxPrice, null),
            minMarks: (item.marks && item.marks.length !== 0) ? item.marks[0] : null,
            maxMarks: (item.marks && item.marks.length !== 0) ? item.marks[1] : null,
            prime: defaultVal(item.prime, null),
          }))
        };
        // 投放组参数
        const targetsGroupsParams = {
          marketId: this.marketId,
          params: this.form.bidPickerForm.items
            .map(item => ({
              bid: item.bid,
              targetingGroupType: item.id,
              state: item.status ? 0 : 1
            }))
        };
        // 自动否定商品投放参数
        const autoNegativeTargetsParams = {
          marketId: this.marketId,
          params: this.form.autoNegTargetPickerForm.items.map(item => ({
            asin: item.asin
          }))
        };
        // 手动动否定商品投放参数
        const manualNegativeTargetsParams = {
          marketId: this.marketId,
          params: this.form.manualNegTargetPickerForm.items.map(item => ({
            asin: defaultVal(item.asin, null),
            brandId: defaultVal(item.brandId, null),
            brandName: defaultVal(item.brandName, null),
          }))
        };
        // 广告组类型
        let groupTargetingType = null;
        // 广告组类型
        (this.manual && this.keywordTarget) && ( groupTargetingType = GroupType().SP.cell.keyword );
        (this.manual && this.productTarget) && ( groupTargetingType = GroupType().SP.cell.product );
        this.auto && ( groupTargetingType = GroupType().SP.cell.auto );
        // console.log('%czs','color: red; font-size: 60px', groupTargetingType);
        // 新增参数
        const { homePercentage,productPercentage, bidStrategyType } = this.form.bidStrategyPickerForm;
        let params = {
          marketId: this.marketId,
          params: [{
            campaignName: this.form.baseInfoForm.campaignName,
            startDate: convertToDate(this.form.baseInfoForm.startDate),
            endDate: isMeaningful(this.form.baseInfoForm.endDate) ? convertToDate(this.form.baseInfoForm.endDate) : null,
            portfolioId: defaultVal(this.form.baseInfoForm.portfolioId, null),
            portfolioName: defaultVal(this.form.baseInfoForm.portfolioName, null),
            dailyBudget: this.form.baseInfoForm.budget,
            targetingType: this.form.baseInfoForm.targetingType,
            bidding: { 
              strategy: bidStrategyType,
              placementBidding: [
                { percentage: homePercentage, placement: 'PLACEMENT_TOP' },
                { percentage: productPercentage, placement: 'PLACEMENT_PRODUCT_PAGE' }
              ]
            },
            groupsParams: {
              marketId: this.marketId,
              params: [{
                groupName: this.form.groupName,
                defaultBid: this.form.defaultBid || null,
                groupTargetingType,
                productParams: {
                  marketId: this.marketId,
                  params: this.form.productPickerForm.items.map(item => ({
                    asin: item.asin,
                    sku: item.msku
                  }))
                },
              }]
            },
          }]
        }
        let add = {};
        // 自动投放时
        if(this.auto) {
          add = {
            negativeKeywordsParams,
            negativeTargetsParams: autoNegativeTargetsParams,
          }
          // 投放组竞价
          if (this.form.bidPickerForm.bidType === AdBidTypeEnum.targetGroup) {
            add.targetsGroupsParams = targetsGroupsParams
          }
          // 默认竞价
            params.params[0].groupsParams.defaultBid = this.form.bidPickerForm.defaultBid
        }
        // 关键词投放时
        if(this.manual && this.keywordTarget) {
          add = { keywordsParams, negativeKeywordsParams }
        }
        // 商品投放时
        if(this.manual && this.productTarget) {
          add = { targetsParams, negativeTargetsParams: manualNegativeTargetsParams }
        }
        Object.assign(params.params[0].groupsParams.params[0], add)
        return params;
      },
      // 商品广告创建
      async campaignsAdd() {
        try {
          const params = await this.campaignsAddParams();
          const { data, msg } = await SP.campaignsAdd(params);
          this.$gjMessage.success(msg);
          this.$gjDestroy();
          this.$emit('created');
        } catch (error) {
          console.log('zs', error);
        } finally {
          this.confirmLoading = false;
        }
        
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
  /deep/ .el-input__suffix-inner{
      height: 32px !important;
      margin-top: 0 !important;
    }
</style>

